module.exports = __webpack_public_path__ + "img/namsan_gallery1.c2f9e9da.jpg";